import { render, staticRenderFns } from "./TermsListLink.vue?vue&type=template&id=009db79a&scoped=true&"
import script from "./TermsListLink.vue?vue&type=script&lang=js&"
export * from "./TermsListLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009db79a",
  null
  
)

export default component.exports